import { Component, forwardRef, OnInit, Type } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CustomNew, NewsModel } from 'app/views/presentations/models/rss.model';
import { Widget } from 'app/views/presentations/widgets/widget';
import { WidgetComponent } from 'app/views/presentations/widgets/widget.component';

export class NewsWidget extends Widget {
    public type: string = 'News';
    public icon: string = 'fa-newspaper-o';
    public nameResourceKey: string = 'modules.editors.news.name';
    public componentType: Type<WidgetComponent> = NewsWidgetComponent;
}

@Component({
    selector: 'psm-news-widget',
    templateUrl: 'news.widget.html'
})
export class NewsWidgetComponent extends WidgetComponent<NewsModel> {
    constructor(private translate: TranslateService) {
        super();
    }

    public async initialize() {
        if (this.content !== undefined) return;

        const customNew = new CustomNew();
        customNew.logoUrl = await this.translate.get('modules.editors.rss.logo-url-default').toPromise();
        customNew.title = await this.translate.get('modules.editors.rss.title-default').toPromise();
        customNew.content = await this.translate.get('modules.editors.rss.content-default').toPromise();

        const content = new NewsModel();
        content.rssSources = [
            await this.translate.get('modules.editors.rss.sources-default1').toPromise(),
            await this.translate.get('modules.editors.rss.sources-default2').toPromise(),
            await this.translate.get('modules.editors.rss.and-so-on').toPromise()
        ];

        content.badwords = [
            await this.translate.get('modules.editors.rss.badwords-default1').toPromise(),
            await this.translate.get('modules.editors.rss.badwords-default2').toPromise(),
            await this.translate.get('modules.editors.rss.and-so-on').toPromise()
        ];
        content.customNews = [customNew];

        this.updateConfig(content);

    }

    public async updateConfig(configs: any) {
        this.content = configs;
    }
}


// WEBPACK FOOTER //
// ./src/app/views/presentations/widgets/news/news.widget.ts